<template>
  <keep-alive>
    <v-container
      fluid
      style="height: 100%; padding:0px; min-height: inherit;"
      class="d-flex flex-column"
    >
      <div
        style="height: 100%; padding:0px; min-height: inherit;"
        class="d-flex flex-row"
        v-if="type == 'Admin'"
      >
        <side-menu class="hidden-sm-and-down" />
        <content-section />
      </div>
      <not-found v-else />
      <v-snackbar v-model="snackbar">
        {{ errorMessage }}
      </v-snackbar>
    </v-container>
  </keep-alive>
</template>
<script>
import { mapState } from "vuex";
import ContentSection from "./AdminProfileContent.vue";
import SideMenu from "../home/AdminHomeSideMenu";
import notFound from "../../NotFound.vue"
export default {
  components: { ContentSection, SideMenu , notFound },
  data() {
    return {
      snackbar: false,
      errorMessage: null
    };
  },
    computed: {
    ...mapState("auth", {
      profile: "profile",
      type: "type"
    }),
  },
  methods: {
    onSelectEvent(event) {
      console.log(event);
    }
  }
};
</script>
<style scoped>
::-webkit-scrollbar {
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px light-grey;
  border-radius: 4px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #feb934;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #f5bd4d;
}
</style>
